import { isMobile } from 'react-device-detect';
import styled from 'styled-components';

const baseFontSize = isMobile ? 14 : 16;

export const StyledDropdown = styled.div<{ color: string }>`
  position: relative;

  .select {
    box-sizing: border-box;
    width: 100%;
    background: #ffffff;
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    justify-content: space-between;
    align-items: center;
    color: #000000;
    font-family: var(--font-family);
    font-size: ${baseFontSize}px;
    text-align: center;
    line-height: ${48 / baseFontSize};
    cursor: pointer;
    border: 1px solid #000000;
    border-radius: .5rem;
    padding: 0 ${16 / baseFontSize}em;

    &:focus, &:hover {
      outline: 0;
      background: var(--lightest-gray);
      border: 1px solid ${({ color }) => color};
    }

    &.opened {
      border: 1px solid ${({ color }) => color};
    }

    &[disabled] {
      cursor: auto;
      &:focus, &:hover {
        outline: 0;
        background: #ffffff;
        border: 1px solid #000000;
      }
    }
  }

  .arrow {
    height: ${10 / baseFontSize}em;
    width: ${10 / baseFontSize}em;
    color: #000000;
    transform: rotate(90deg);

    &.rotated {
      transform: rotate(270deg);
      // transition: transform 0.25s;
    }
  }
`;

export const StyledDropdownMenu = styled.ol`
  box-sizing: border-box;
  max-height: 500px;
  background: #ffffff;
  list-style: none;
  border: 1px solid var(--light-gray);
  border-radius: .5rem;
  margin: 0;
  padding: 0;
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 100%;
  margin-top: 4px;
  width: 100%;

  li {
    height: ${48 / baseFontSize}em;
    font-size: ${baseFontSize}px;
    margin: ${2 / baseFontSize}em;

    &.hidden {
      display: none;
    }

    &:first-of-type {
      button {
        border-radius: 5px 5px 0 0;
      }
    }
    &:last-of-type {
      button {
        border-radius: 0 0 5px 5px;
      }
    }
  }

  // TODO: refactor with BaseButton/ClydeButton at some point
  button {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background: transparent;
    color: #000000;
    font-family: var(--font-family);
    font-size: ${baseFontSize}px;
    text-align: center;
    text-rendering: inherit;
    letter-spacing: inherit;
    word-spacing: inherit;
    text-indent: inherit;
    text-shadow: inherit;
    text-align: inherit;
    border: none;
    cursor: pointer;
    padding: 0 ${16 / baseFontSize}em;

    &:focus,
    &:hover {
      outline: 0;
      background: var(--lightest-gray);
    }
  }
`;
